import type { Address } from '$types/address';
import { fetchCirclesAvatarFromEnvio } from '$services/circlesV2Utils/profile';
import type { User } from '$types/user';
import { mapAvatarTypeToUserType } from '$types/userType';
import type { CirclesAvatarFromEnvio } from '$types/envioTypes';
import { getImageFromCidV0 } from './getImageFromCid';
import { TrustStatus } from '$types/trustStatus';
import { users } from '$states/users.svelte';
import { zeroAddress } from 'viem';

export const loadUser = async (
  address: Address,
  circlesAvatar?: CirclesAvatarFromEnvio,
): Promise<User> => {
  let circlesAvatarFromEnvio: Partial<CirclesAvatarFromEnvio> | null = null;

  if (address === zeroAddress) {
    return <User>{
      address,
      name: 'the blackhole', // this should never happen
    };
  }

  if (!circlesAvatar) {
    circlesAvatarFromEnvio = await fetchCirclesAvatarFromEnvio(address);
  } else {
    circlesAvatarFromEnvio = circlesAvatar;
  }

  if (!circlesAvatarFromEnvio) {
    return <User>{
      address,
      name: '',
    };
  }

  const [trust, picture] = await Promise.all([
    TrustStatus.NONE,
    getImageFromCidV0(circlesAvatarFromEnvio.profile?.cidV0),
  ]);

  return <User>{
    ...circlesAvatarFromEnvio,
    address: address,
    name: circlesAvatarFromEnvio.profile?.name,
    type: mapAvatarTypeToUserType(circlesAvatarFromEnvio.avatarType),
    version: circlesAvatarFromEnvio.version,
    cidV0: circlesAvatarFromEnvio.profile?.cidV0,
    location: circlesAvatarFromEnvio.profile?.location,
    picture,
    description: circlesAvatarFromEnvio.profile?.description?.replace(/\\\\n/g, '\n'),
    isCirclesUser: circlesAvatarFromEnvio?.avatarType !== 'Unknown',
    trust,
    verificationBadge: circlesAvatarFromEnvio.verificationBadge,
    primaryGroup: circlesAvatarFromEnvio?.primaryGroup,
    mintHandlerAddress: circlesAvatarFromEnvio?.mintHandlerAddress,
    feeCollectionAddress: circlesAvatarFromEnvio?.feeCollectionAddress,
    isEarlySupporter: circlesAvatarFromEnvio?.isEarlySupporter,
    trustsReceived: circlesAvatarFromEnvio?.trustsReceived,
  };
};

export const updateUserInCache = (updatedUser: User) => {
  //Envio is slow, so we need to update the user in cache sometimes
  //we cannot rely  on local states always
  users
    .get(updatedUser.address, async (_) => {
      return updatedUser;
    })
    .then((stateItem) => {
      stateItem.set(updatedUser);
    });
};
